export const characterCodes = {
  EOF: -1,
  SPACE: 32,
  BANG: 33,
  DOUBLEQUOTE: 34,
  OPENING_BRACKET: 40,
  CLOSING_BRACKET: 41,
  ASTERISK: 42,
  COMMA: 44,
  DASH: 45,
  DOT: 46,
  EQUALS: 61,
  BACKSLASH: 92,
};

export const durationUnitChars = ['n', 's', 'm', 'h', 'd'];
